module.exports = __webpack_public_path__ + "static/fakeProductLi-b82ca63d1e71137378a0525857e204f1.jpg";